module.exports = __webpack_public_path__ + "media/images/emblems/Le_Bemont_Blazono-948e8c7bb6aa197dd102b4945fc02ed7.png";